import React from 'react'

const AddBook = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="22"
            viewBox="0 0 18 22"
        >
            <g
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            >
                <g stroke="currentColor" transform="translate(-105 -521)">
                    <g transform="translate(-1)">
                        <g transform="translate(83 107)">
                            <g transform="translate(24 415)">
                                <g strokeWidth="2">
                                    <path d="M0 17.5A2.5 2.5 0 012.5 15H16" />
                                    <path d="M2.5 0H16v20H2.5A2.5 2.5 0 010 17.5v-15A2.5 2.5 0 012.5 0z" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default React.memo(AddBook)
